import { makeAutoObservable, runInAction } from 'mobx'
import type { Notify } from '@/Ship/Contracts/Notify'
import { SendAssignmentPushTask } from '../Tasks/SendAssignmentPushTask'

/**
 * Local store of `PushModal` — sends a push notification to a specific assignment's driver.
 */
export class PushModalStore {
    open = false
    task: any = null
    message = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    openFor(task: any): void {
        this.task = task
        this.message = ''
        this.loading = false
        this.open = true
    }

    close(): void {
        this.open = false
        this.task = null
        this.message = ''
        this.loading = false
    }

    setMessage(v: string): void {
        this.message = v
    }

    async send(notify: Notify): Promise<boolean> {
        if (!this.task?.uuid) return false
        const trimmed = this.message.trim()
        if (!trimmed) {
            notify.error('Введіть текст повідомлення')
            return false
        }
        this.loading = true
        try {
            await SendAssignmentPushTask(this.task.uuid, trimmed)
            notify.success('Push-повідомлення відправлено')
            this.close()
            return true
        } catch (e: any) {
            notify.error(e?.message || 'Не вдалося відправити push')
            runInAction(() => { this.loading = false })
            return false
        }
    }
}
